// Sibling imports
const {
  DISMISS
} = require('./actions')
const LightweightEngagementTutorialRecord = require('./record')

// eslint-disable-next-line complexity
function lightweightEngagementTutorialReducer(state = new LightweightEngagementTutorialRecord, action) {
  switch (action.type) {
    case DISMISS:
      return state && state.merge({ isVisible: false })
    default:
      return state
  }
}

module.exports = lightweightEngagementTutorialReducer
